import React from 'react'
import PropTypes from 'prop-types'

const ModuleContainer = React.forwardRef(({ children, className, dataTrackingName }, ref) => {
  return (
    <div
      data-tracking-name={dataTrackingName}
      className={`moduleContainer
        mx-16
        720:mx-24
        1000:mx-32
        1280:mx-auto 1280:max-w-1216
        ${className}
      `}
      ref={ref}
    >
      {children}
    </div>
  )
})

ModuleContainer.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
}

ModuleContainer.defaultProps = {
  children: '',
  className: '',
}

export default ModuleContainer
